import styled from "@emotion/styled";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import OAuth2Authentication from "../Auth2Authenticator/OAuth2Authentication";
import { useState } from "react";

const theme = createTheme({
  palette: {
    common: {
      black: "#000",
      white: "#fff",
    },
  },
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function AuthenticatedUser(props) {
  const {
    children,
    value,
    index,
    connectionDetails,
    activeUsers,
    orgId,
    apiKey,
    dataCenterUrl,
    dataCenter,
    zApiKey,
    setSnack,
    currentUser,
    handleInvite,
    handleRevokeUser,
    handleCheckUserAuthStatus,
    handlefetchConnections,
    ...other
  } = props;

  let scopes = connectionDetails?.data?.scopes?.map(
    (scope) => scope?.scope?.name
  );
  let submitData = {
    scopes,
    connName: connectionDetails?.data?.connName,
    connApiName: connectionDetails?.data?.connApiName,
  };

  const [userEmail, setUserEmail] = useState();
  const [serviceAuth, setServiceAuth] = useState(false);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (value != index) {
    return <></>;
  }

  console.log("object", activeUsers);
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ maxWidth: 1000 }} p={3}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>User Name</StyledTableCell>
                <StyledTableCell align="left">Email</StyledTableCell>
                <StyledTableCell align="left">Action</StyledTableCell>
                <StyledTableCell align="left"></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
              activeUsers?.map((user) => {
                let tempUser = connectionDetails?.users?.find(
                  (userEmail) => user?.email === userEmail
                );
                return (
                  <StyledTableRow key={user.full_name}>
                    <StyledTableCell component="th" scope="row">
                      {user.full_name}
                    </StyledTableCell>
                    <StyledTableCell align="left">{user.email}</StyledTableCell>
                    <StyledTableCell align="left">
                      {tempUser ? (
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          fullWidth
                          onClick={() => {
                            setUserEmail((prev) => user?.email);
                            handleClickOpen();
                          }}
                        >
                          Revoke
                        </Button>
                      ) : (
                        <>
                          {user?.email == currentUser?.email ? (
                            <OAuth2Authentication
                              serviceAuth={serviceAuth}
                              setServiceAuth={setServiceAuth}
                              orgId={orgId}
                              apiKey={apiKey}
                              dataCenterUrl={dataCenterUrl}
                              dataCenter={dataCenter}
                              zApiKey={zApiKey}
                              setSnack={setSnack}
                              currentUser={currentUser}
                              service={connectionDetails?.service}
                              submitData={submitData}
                              settingId={connectionDetails?.settingId}
                              handlefetchConnections={handlefetchConnections}
                            />
                          ) : (
                            <Button
                              size="small"
                              variant="outlined"
                              fullWidth
                              onClick={() => {
                                handleInvite(user?.email);
                              }}
                            >
                              Invite
                            </Button>
                          )}
                        </>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Revoke Connection for this user?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Revoke connection will remove this user from accessing data previously given to this user. 
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Disagree</Button>
            <Button
              autoFocus
              onClick={async () => {
                await handleRevokeUser(userEmail);
                handleClose()
              }}
            >
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </ThemeProvider>
  );
}

export default AuthenticatedUser;
